import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mt-1 text-success"
};
const _hoisted_2 = {
    key: 1,
    class: "mt-1 text-danger"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => (_ctx.setPushNotification && _ctx.setPushNotification(...args)))
        }, "Setup"),
        _createVNode(_TransitionGroup, null, {
            default: _withCtx(() => [
                (_ctx.isGrantedFlashMsgActive)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.$t('notifications_allowed')), 1))
                    : _createCommentVNode("", true),
                (_ctx.isDeniedFlashMsgActive)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t('notifications_denied')), 1))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        })
    ], 64));
}
